import { DefaultTheme } from "styled-components";

const defaultTheme: DefaultTheme = {
  colors: {
    softBlack: "#181a18",
    white: "#f9f9f9",
    black: "${({ theme }) => theme.colors.softBlack}",
    tango: "#f37125",
    pearlBush: "#e3d9d0",
    silverChalice: "#aba7a3",
    dustyGrey: "#9B9692",
  },
  breakpoints: {
    xs: "(max-width: 480px)",
    sm: "(max-width: 680px)",
    md: "(max-width: 992px)",
    lg: "(max-width: 1500px)",
    xl: "(max-width: 1650px)",
    xxl: "(max-width: 2000px)",

    // use for hover
    hover: "(min-width: 821px)",
  },
};

export default defaultTheme;
